<template>
  <div>
    <div @click="openModal()" class="singup-button">
      Sign Up
    </div>

    <div class="modal micromodal-slide modal-global-selector !w-full !text-black !bg-transparent" style="background: transparent" id="newsletterModal" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close></div>
      <div class="modal__container !rounded-xl" role="dialog" aria-modal="true"
           aria-labelledby="modal-global-selector-title">
        <header class="modal__header flex flex-row-reverse">
          <button class="modal__close__button" aria-label="Close modal" data-micromodal-close @click="closeModal()">
            <img class="close-button ls-is-cached lazyloaded" style="margin-top: 20px; margin-right: 20px;" data-dismiss="modal" data-src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg" src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg">
          </button>
        </header>
        <main class="modal__content" id="modal-global-selector-content">
          <div class="wrapper subscription-container">
            <div class="hero-image">
              <img class="m-auto" src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg" alt="">
            </div>
            <div class="hero-title w-100" v-html="translations.subscription_modal_title">
              Put <span class="red">Gambling.com</span> in Your Inbox
            </div>
            <div class="hero-text w-100">
              {{ translations.subscription_modal_text }}
            </div>
            <div id="subscription-form-subscribe">
              <subscription-form-tw></subscription-form-tw>
            </div>
          </div>
          <div class="newsletter-subscription-response hidden">
            <div class="hero-image">
              <img class="m-auto" src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg" alt="">
            </div>
            <div class="hero-title w-100" v-html="translations.subscribed_title">
            </div>
            <div class="hero-text w-100" v-html="translations.subscribed_text">
            </div>
          </div>
        </main>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      id: null,
      translations: {
        email_enter_email: null,
        subscribed_title: null,
        subscribed_text: null,
        subscription_modal_title: null,
        subscription_modal_text: null,
        subscribe_button_text: null,
        agree_message: null,
        input_validation_error: null,
        checkbox_validation_error: null,
        email_validation_error: null,
      },
    };
  },
  mounted() {
    this.translations = this.$root.translations;
  },
  methods: {
    openModal: function () {
      console.log('clicked');
      MicroModal.show('newsletterModal');
      // $('#newsletterModal').modal('show');
      // this.$modal.show('newsletter-modal');
    },
    closeModal: function() {
      MicroModal.close('newsletterModal');
    },
    send: function() {
    }
  }
};

</script>
